<div class="names-container">
  @if (loaded) {
    <mat-checkbox [(ngModel)]="applyNameToAllLng" data-cy="node-name-all-languages">
      {{ 'TREE.SAME_NAME_ALL_LANGUAGES' | translate }}
    </mat-checkbox>

    @if (applyNameToAllLng) {
      <div class="lng-content">
        <app-emu-input
          data-cy="node-name-input"
          [value]="currentLangName"
          (valueChange)="setAllNames($event)"
          name="TREE.NODE_NAME"
          [placeholder]="getDefaultName()"
        ></app-emu-input>
      </div>
    } @else {
      <mat-tab-group>
        @for (name of data.names; track name) {
          <mat-tab class="name">
            <ng-template mat-tab-label>
              <div class="lng-label" [attr.data-cy]="name.lng.toLocaleUpperCase()">
                <mat-icon class="flag-svg">
                  <img
                    alt="{{ name.lng.toLocaleUpperCase() }}"
                    fill
                    ngSrc="../../assets-common/flags/{{ name.lng.toLocaleUpperCase() }}.svg"
                  />
                </mat-icon>
                <span>{{ getLanguageNameToTranslate(name.lng) | translate }}</span>
              </div>
            </ng-template>
            <div class="lng-content">
              <app-emu-input
                data-cy="node-name-input"
                [(value)]="name.name"
                name="TREE.NODE_NAME"
                [placeholder]="getDefaultName()"
              ></app-emu-input>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    }
  } @else {
    <app-skeleton></app-skeleton>
  }
</div>
